import React, { Component, useState } from 'react';
import { Navbar } from 'reactstrap';
import Profile from './Profile';
import './Header.css';

const Header = () => {

    return (
        <header>
            <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow" container light style={{
                background:"#41533d",
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center'
            }}>
            <Profile />
            </Navbar>
        </header>
    );
}


export default Header
